import { Suspense } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getAccountCreationSettings } from 'utils/helpers';
import useIsLoggedIn from 'utils/hooks/use_is_logged_in';
import BookingHistory from 'components/booking_history';
import AccountView from '../account_view';
import CreateAccount from '../auth/create_account';
import Login from '../auth/login';
import ResetPassword from '../auth/reset_password';
import SetPassword from '../auth/set_password';

// eslint-disable-next-line react/prop-types
export const PrivateRoute = ({ children, ...routeProps }) => {
  const authorized = useIsLoggedIn();
  return (
    <Route
      {...routeProps} // eslint-disable-line react/jsx-props-no-spreading
      render={({ location }) =>
        authorized ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/account/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

// eslint-disable-next-line react/prop-types
const PublicRoute = ({ children, ...routeProps }) => {
  const authorized = useIsLoggedIn();

  return (
    <Route
      {...routeProps} // eslint-disable-line react/jsx-props-no-spreading
      render={() => (
        <>
          {authorized ? (
            <Redirect to="/account" />
          ) : (
            <div className="container container--x-narrow py-primary">
              {children}
            </div>
          )}
        </>
      )}
    />
  );
};

export const AccountNavigation = () => {
  const accountCreationSettings = getAccountCreationSettings();

  return (
    <>
      <Suspense fallback={<Skeleton height={800} />}>
        <Switch>
          <PublicRoute path="/account/login">
            <Login />
          </PublicRoute>
          <PublicRoute path="/account/create-account">
            {accountCreationSettings.enabled ? (
              <CreateAccount />
            ) : (
              <Redirect to="/account/login" />
            )}
          </PublicRoute>
          <PublicRoute path="/account/reset-password/confirm">
            <SetPassword />
          </PublicRoute>
          <PublicRoute path="/account/reset-password">
            <ResetPassword />
          </PublicRoute>
          <PrivateRoute path="/account/history">
            <BookingHistory />
          </PrivateRoute>
          <PrivateRoute>
            <AccountView />
          </PrivateRoute>
        </Switch>
      </Suspense>
    </>
  );
};
